<template>
  <div class="md-layout">
    <md-dialog :md-active.sync="showExtrasDialog">
      <!-- <md-dialog-title>Add an Extra </md-dialog-title> -->
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(addExtra)">
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <h6>Select an Extra</h6>

              <md-field>
                <label for="extra">Extra</label>
                <md-select v-model="selectedExtra" name="extra" id="extra">
                  <md-option
                    v-for="(extra, index) in extras"
                    :key="extra.id"
                    :value="index"
                  >
                    {{ extra.title }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
          </div>

          <md-dialog-actions>
            <md-button class="md-primary md-dense" @click="cancel"
              >Cancel</md-button
            >
            <md-button type="submit" class="md-primary md-dense">Add</md-button>
          </md-dialog-actions>
        </form>
      </ValidationObserver>
    </md-dialog>
  </div>
</template>

<script>
import bookingApi from "@/services/api/booking";
import departureApi from "@/services/api/departure";

export default {
  name: "BookingAddExtra",

  props: ["showExtrasDialog", "booking", "traveller"],

  data() {
    return {
      extra: {},
      extras: [],
      selectedExtra: -1
    };
  },

  components: {},

  methods: {
    cancel() {
      this.$emit("cancel");
    },

    addExtra() {
      let data = {
        booking: this.booking,
        traveller: this.traveller,
        extra: this.extras[this.selectedExtra]
      };

      bookingApi.addTravellerExtra(data).then(response => {
        let newData = {
          extra: response.data,
          traveller: data.traveller
        };
        this.$emit("new-extra", newData);
      });
    }
  },

  mounted() {
    departureApi.getExtras(this.booking.departure).then(response => {
      this.extras = response.data;
    });
  }
};
</script>
